import type { ShapeData } from '@/lib/shapes/types/shape-data'
import { resolvePlacedClikArtId } from '@/lib/clikart/sync-clikart-placement-from-shapes'

/**
 * True when the selection is exactly one placed ClikArt, the case the Left Panel shows ClikArt info
 * for (WMPCM-11032). The panel follows this: it opens when a ClikArt becomes the selection, by click
 * or by a drop, and goes away when the selection empties (WMPCM-13378).
 */
export function isSingleClikArtSelection(shapes: readonly ShapeData[]): boolean {
  return shapes.length === 1 && resolvePlacedClikArtId(shapes[0]) !== null
}
